import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MetaService } from 'app/meta.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-view-user-order-complete-info',
  templateUrl: './view-user-order-complete-info.component.html',
  styleUrls: ['./view-user-order-complete-info.component.scss']
})
export class ViewUserOrderCompleteInfoComponent {

  userOrderCompleteInfo: any
  isHourly: boolean = false
  constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ViewUserOrderCompleteInfoComponent>,
        public meta: MetaService,
        public toastr: ToastrService, 
  ){
    this.userOrderCompleteInfo = this.data.userOrderCompleteInfo
    this.isHourly = this.userOrderCompleteInfo.plan_duration.plan.is_hourly
  }

  ngOnInit(){
  }

}
